"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_USE_OF_REP_CONTACTS = exports.ROLE_LMIA_JOB_BANK_POSTING = exports.COMPANY_APPLICATION_LMIA_HIGH_LOW_WAGE = exports.COMPANY_APPLICATION_LMIA_ACADEMICS = exports.COMPANY_APPLICATION_LMIA_CAREGIVER = exports.COMPANY_APPLICATION_LMIA_EXPRESS_ENTRY = exports.COMPANY_APPLICATION_LMIA_AGRICULTURE = exports.COMPANY_APPLICATION_LMIA_SEASONAL_AGRICULTURE = exports.COMPANY_APPLICATION_LMIA_GTS = exports.COMPANY_GENERAL_APPLICATION_LMIA = exports.COMPANY_ROLE_LMIA = exports.COMPANY_INTAKE_LMIA = void 0;
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
exports.COMPANY_INTAKE_LMIA = (0, form_1.form)({
    name: "COMPANY_INTAKE_LMIA",
    title: "Company intake form",
    id: 69,
    content: [
        question_groups_1.QuestionGroup["COMPANY_INTAKE_EMPLOYER"],
        question_groups_1.QuestionGroup["COMPANY_INTAKE_BUSINESS_PROFILE"],
        question_groups_1.QuestionGroup["COMPANY_INTAKE_LABOUR_MARKET_IMPACT"],
        question_groups_1.QuestionGroup["COMPANY_INTAKE_POTENTIAL_BENEFITS"],
    ],
});
exports.COMPANY_ROLE_LMIA = (0, form_1.form)({
    name: "COMPANY_ROLE_LMIA",
    title: "Role information",
    id: 71,
    content: [
        question_groups_1.QuestionGroup["COMPANY_LMIA_ROLE_HOURS_PAY"],
        question_groups_1.QuestionGroup["COMPANY_LMIA_ROLE_JOB_OFFER"],
        question_groups_1.QuestionGroup["COMPANY_LMIA_ROLE_EMPLOYMENT_BENEFITS"],
    ],
});
exports.COMPANY_GENERAL_APPLICATION_LMIA = (0, form_1.form)({
    name: "COMPANY_GENERAL_APPLICATION_LMIA",
    title: "General application information",
    id: 72,
    content: [question_groups_1.QuestionGroup["COMPANY_LMIA_GENERAL_APPLICATION_EMPLOYMENT"]],
});
exports.COMPANY_APPLICATION_LMIA_GTS = (0, form_1.form)({
    name: "COMPANY_APPLICATION_LMIA_GTS",
    title: "LMIA Global Talent Stream (GTS)",
    id: 73,
    content: [question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_GTS"]],
});
exports.COMPANY_APPLICATION_LMIA_SEASONAL_AGRICULTURE = (0, form_1.form)({
    name: "COMPANY_APPLICATION_LMIA_SEASONAL_AGRICULTURE",
    title: "LMIA Seasonal Agriculture Worker Program",
    id: 74,
    content: [
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_SEASONAL_AGRICULTURE"],
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_AGRICULTURAL_ALL"],
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_RECRUITMENT"],
    ],
});
exports.COMPANY_APPLICATION_LMIA_AGRICULTURE = (0, form_1.form)({
    name: "COMPANY_APPLICATION_LMIA_AGRICULTURE",
    title: "LMIA Agriculture Worker Program",
    id: 78,
    content: [
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_AGRICULTURE"],
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_AGRICULTURAL_ALL"],
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_RECRUITMENT"],
    ],
});
exports.COMPANY_APPLICATION_LMIA_EXPRESS_ENTRY = (0, form_1.form)({
    name: "COMPANY_APPLICATION_LMIA_EXPRESS_ENTRY",
    title: "Express Entry",
    id: 79,
    content: [
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_EXPRESS_ENTRY"],
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_RECRUITMENT"],
    ],
});
exports.COMPANY_APPLICATION_LMIA_CAREGIVER = (0, form_1.form)({
    name: "COMPANY_APPLICATION_LMIA_CAREGIVER",
    title: "In-Home Caregiver",
    id: 80,
    content: [
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_CAREGIVER"],
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_RECRUITMENT"],
    ],
});
exports.COMPANY_APPLICATION_LMIA_ACADEMICS = (0, form_1.form)({
    name: "COMPANY_APPLICATION_LMIA_ACADEMICS",
    title: "Academics, medical doctors, specialists or registered nurses",
    id: 82,
    content: [
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_HIGH_WAGE_TRANSITION"],
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_RECRUITMENT"],
    ],
});
exports.COMPANY_APPLICATION_LMIA_HIGH_LOW_WAGE = (0, form_1.form)({
    name: "COMPANY_APPLICATION_LMIA_HIGH_LOW_WAGE",
    title: "High or Low - wage positions",
    id: 84,
    content: [
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_HIGH_LOW_WAGE"],
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_HIGH_WAGE_TRANSITION"],
        question_groups_1.QuestionGroup["COMPANY_APPLICATION_LMIA_RECRUITMENT"],
    ],
});
exports.ROLE_LMIA_JOB_BANK_POSTING = (0, form_1.form)({
    name: "ROLE_LMIA_JOB_BANK_POSTING",
    title: "Job Bank Posting",
    id: 85,
    content: [
        question_groups_1.QuestionGroup["ROLE_LMIA_JOB_BANK_POSTING_TARGET_AUDIENCE"],
        question_groups_1.QuestionGroup["ROLE_LMIA_JOB_BANK_POSTING_DETAILS"],
        question_groups_1.QuestionGroup["ROLE_LMIA_JOB_BANK_POSTING_REQUIREMENTS"],
        question_groups_1.QuestionGroup["ROLE_LMIA_JOB_BANK_POSTING_HOW_APPLY"],
    ],
});
exports.COMPANY_USE_OF_REP_CONTACTS = (0, form_1.form)({
    name: "COMPANY_USE_OF_REP_CONTACTS",
    title: "Use of Representative Contacts",
    id: 86,
    content: [question_groups_1.QuestionGroup["COMPANY_LMIA_USE_OF_REP_CONTACTS"]],
});
